import { get, post } from './api.js';

var ERRORS = {
  en: {
    required: 'All fields are required',
    emailRequired: 'Email and password are required',
    resetEmail: 'Email required',
    invalid: 'Invalid email or password',
    passwordShort: 'Password must be at least 8 characters',
    exists: 'Email already registered',
    tokenMissing: 'Invalid or expired reset link.',
    resetSuccess: 'We\'ve sent a reset link straight to your inbox.',
    resetSuccessBody: 'We\'ve sent a reset link straight to your inbox. It\'s on its way to {email}.',
    resetResend: 'Didn\'t receive it? Resend',
    resetResent: 'Sent again. Check your inbox.',
    general: 'Something went wrong. Please try again.',
    registerFailed: 'Registration failed'
  },
  ru: {
    required: 'Все поля обязательны',
    emailRequired: 'Email и пароль обязательны',
    resetEmail: 'Email обязателен',
    invalid: 'Неверный email или пароль',
    passwordShort: 'Пароль должен быть не менее 8 символов',
    exists: 'Email уже зарегистрирован',
    tokenMissing: 'Недействительная или истекшая ссылка.',
    resetSuccess: 'Мы отправили ссылку для сброса прямо на вашу почту.',
    resetSuccessBody: 'Мы отправили ссылку для сброса прямо на вашу почту. Она уже в пути к {email}.',
    resetResend: 'Не пришло? Отправить снова',
    resetResent: 'Отправлено снова. Проверьте почту.',
    general: 'Что-то пошло не так. Попробуйте снова.',
    registerFailed: 'Ошибка регистрации'
  },
  he: {
    required: 'כל השדות חובה',
    emailRequired: 'נדרשים אימייל וסיסמה',
    resetEmail: 'נדרש אימייל',
    invalid: 'אימייל או סיסמה שגויים',
    passwordShort: 'הסיסמה חייבת להכיל לפחות 8 תווים',
    exists: 'האימייל כבר רשום',
    tokenMissing: 'קישור איפוס לא חוקי או פג תוקף.',
    resetSuccess: 'שלחנו קישור איפוס ישירות לתיבת הדוא"ל שלך.',
    resetSuccessBody: 'שלחנו קישור איפוס ישירות לתיבת הדוא"ל שלך. הוא בדרכה אל {email}.',
    resetResend: 'לא הגיע? שלח שוב',
    resetResent: 'נשלח שוב. בדוק את תיבת הדוא״ל.',
    general: 'משהו השתבש. נסו שוב.',
    registerFailed: 'הרשמה נכשלה'
  }
};

function __(locale, key) {
  return (ERRORS[locale] || ERRORS.en)[key] || ERRORS.en[key];
}

export function safeRedirect(target, fallback) {
  if (typeof target !== 'string') return fallback;
  if (target.charAt(0) !== '/') return fallback;
  if (target.charAt(1) === '/' || target.includes('\\')) return fallback;
  return target;
}

var TOAST_ICONS = {
  info: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z"/><path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"/></svg>',
  success: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m17 14 3 3.3a1 1 0 0 1-.7 1.7H4.7a1 1 0 0 1-.7-1.7L7 14h-.3a1 1 0 0 1-.7-1.7L9 9h-.2A1 1 0 0 1 8 7.3L12 3l4 4.3a1 1 0 0 1-.8 1.7H15l3 3.3a1 1 0 0 1-.7 1.7H17Z"/><path d="M12 22v-3"/></svg>',
  attention: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m8 3 4 8 5-5 5 15H2L8 3z"/></svg>'
};

window.showToast = function (msg, type) {
  var el = document.getElementById('toast');
  if (!el) return;
  var t = TOAST_ICONS[type] ? type : 'info';
  var icon = el.querySelector('.toast__icon');
  if (icon) icon.innerHTML = TOAST_ICONS[t];
  el.dataset.type = t;
  var text = el.querySelector('.toast__text');
  if (text) text.textContent = msg;
  el.hidden = false;
};

// Design-iteration helper: ?toast=your text&toastType=info|success|attention
var _toastDemo = new URLSearchParams(window.location.search).get('toast');
if (_toastDemo) {
  window.addEventListener('DOMContentLoaded', function () {
    window.showToast(_toastDemo, new URLSearchParams(window.location.search).get('toastType') || 'info');
  });
}

document.addEventListener('click', function () {
  var el = document.getElementById('toast');
  if (el && !el.hidden) el.hidden = true;
});

document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') {
    var el = document.getElementById('toast');
    if (el && !el.hidden) el.hidden = true;
  }
});

var _sessionPromise = null;

export async function getSession() {
  if (_sessionPromise) return _sessionPromise;
  _sessionPromise = _fetchSession();
  return _sessionPromise;
}

async function _fetchSession() {
  try {
    const data = await get('/auth/session');
    return (data && data.user) || null;
  } catch {
    return null;
  } finally {
    _sessionPromise = null;
  }
}

// Password toggle
function initPasswordTools() {
  if (document.querySelector('[data-toggle-password]') && document.querySelector('[data-toggle-password]')._pwReady) return;
  document.querySelectorAll('[data-toggle-password]').forEach(function(btn) {
    btn._pwReady = true;
    // Prevent the button from stealing focus on tap/mouse, which would blur the
    // password input and dismiss the keyboard on the installed PWA.
    btn.addEventListener('pointerdown', function(e) { e.preventDefault(); });
    btn.addEventListener('click', function() {
      var input = document.getElementById(this.getAttribute('data-toggle-password'));
      if (!input) return;
      var isPassword = input.type === 'password';
      input.type = isPassword ? 'text' : 'password';
      this.classList.toggle('is-revealed', input.type === 'text');
      this.setAttribute('aria-label', isPassword ? 'Hide password' : 'Show password');
      // Re-focus the input and restore the caret so the keyboard stays open.
      input.focus({ preventScroll: true });
      var len = input.value.length;
      try { input.setSelectionRange(len, len); } catch (e) {}
    });
  });
}

function initSigninForm() {
  var form = document.getElementById('signin-form');
  if (!form || form._authReady) return;
  form._authReady = true;

  form.addEventListener('submit', async function (e) {
    e.preventDefault();
    var submitBtn = form.querySelector('button[type="submit"]');
    var email = form.querySelector('#signin-email').value;
    var password = form.querySelector('#signin-password').value;
    var locale = form.dataset.locale || 'en';

    if (!email || !password) {
      showToast(__(locale, 'emailRequired'));
      return;
    }

    submitBtn.disabled = true;

    try {
      await post('/auth/signin', { email: email, password: password });
      var params = new URLSearchParams(window.location.search);
      window.location.href = safeRedirect(params.get('redirect'), '/' + locale + '/me/');
    } catch (err) {
      showToast(err.status ? (err.message || __(locale, 'invalid')) : __(locale, 'general'), 'attention');
      submitBtn.disabled = false;
    }
  });
}

function initSignupForm() {
  var form = document.getElementById('signup-form');
  if (!form || form._authReady) return;
  form._authReady = true;

  form.addEventListener('submit', async function (e) {
    e.preventDefault();
    var submitBtn = form.querySelector('button[type="submit"]');
    var name = form.querySelector('#signup-name').value.trim();
    var email = form.querySelector('#signup-email').value.trim();
    var password = form.querySelector('#signup-password').value;
    var marketing = form.querySelector('[name="marketing_consent"]');
    var marketingConsent = marketing ? marketing.checked : false;
    var locale = form.dataset.locale || 'en';

    if (!name || !email || !password) {
      showToast(__(locale, 'required'));
      return;
    }

    submitBtn.disabled = true;

    try {
      await post('/auth/signup', { name: name, email: email, password: password, locale: locale, marketing_consent: marketingConsent });
      var params = new URLSearchParams(window.location.search);
      var redirect = safeRedirect(params.get('redirect'), null);
      var target = '/' + locale + '/me/signup/check-email/';
      if (redirect) target += '?redirect=' + encodeURIComponent(redirect);
      window.location.replace(target);
    } catch (err) {
      showToast(err.status ? (err.message || __(locale, 'registerFailed')) : __(locale, 'general'), 'attention');
      submitBtn.disabled = false;
    }
  });
}

function initResetPasswordStep1Form() {
  var form = document.getElementById('reset-password-step1-form');
  if (!form || form._authReady) return;
  form._authReady = true;

  form.addEventListener('submit', async function (e) {
    e.preventDefault();
    var submitBtn = form.querySelector('button[type="submit"]');
    var email = form.querySelector('#forgot-email').value.trim();
    var locale = form.dataset.locale || 'en';

    if (!email) {
      showToast(__(locale, 'resetEmail'));
      return;
    }

    submitBtn.disabled = true;

    try {
      await post('/auth/reset-password', { email: email });
      form.innerHTML = '<div style="text-align:center;padding:var(--space-2xl) 0">'
        + '<div style="width:3rem;height:3rem;border-radius:50%;background:var(--color-accent);display:inline-flex;align-items:center;justify-content:center;margin-bottom:var(--space-lg)">'
          + '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="var(--color-on-accent)" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>'
        + '</div>'
        + '<h1 style="margin-bottom:var(--space-xs)">Yay!</h1>'
        + '<p style="color:var(--color-text-muted);font-size:var(--font-size-md);margin-bottom:var(--space-lg)">' + __(locale, 'resetSuccessBody').replace('{email}', email) + '</p>'
        + '<div class="auth-alt">'
          + '<a class="auth-alt__cta" href="/' + locale + '/me/signin/">Back to sign in</a>'
        + '</div>'
        + '<div class="auth-alt">'
          + '<span class="auth-alt__text">Didn\'t receive it?</span>'
          + '<button class="auth-alt__cta" style="background:none;border:none;cursor:pointer;padding:0;font:inherit;color:inherit" data-resend-btn>' + __(locale, 'resetResend') + '</button>'
        + '</div>'
      + '</div>';
      var resendBtn = form.querySelector('[data-resend-btn]');
      if (resendBtn) {
        resendBtn.addEventListener('click', async function () {
          try {
            await post('/auth/reset-password', { email: email });
            showToast(__(locale, 'resetResent'), 'success');
          } catch {
            showToast(__(locale, 'general'), 'attention');
          }
        });
      }
    } catch {
      showToast(__(locale, 'general'), 'attention');
      submitBtn.disabled = false;
    }
  });
}

function initResetPasswordStep2Form() {
  var form = document.getElementById('reset-password-step2-form');
  if (!form || form._authReady) return;
  form._authReady = true;

  form.addEventListener('submit', async function (e) {
    e.preventDefault();
    var successEl = document.getElementById('reset-success');
    var submitBtn = form.querySelector('button[type="submit"]');
    var password = form.querySelector('#reset-password').value;
    var locale = form.dataset.locale || 'en';
    var params = new URLSearchParams(window.location.search);
    var token = params.get('token');

    if (!token) {
      showToast(__(locale, 'tokenMissing'), 'attention');
      return;
    }

    if (!password || password.length < 8) {
      showToast(__(locale, 'passwordShort'));
      return;
    }

    submitBtn.disabled = true;
    successEl.hidden = true;

    try {
      await post('/auth/reset-password/confirm', { token: token, password: password });
      successEl.hidden = false;
      submitBtn.disabled = false;
    } catch (err) {
      showToast(err.status ? (err.message || __(locale, 'general')) : __(locale, 'general'), 'attention');
      submitBtn.disabled = false;
    }
  });
}

function initAuth() {
  initPasswordTools();
  initSigninForm();
  initSignupForm();
  initResetPasswordStep1Form();
  initResetPasswordStep2Form();
}

document.addEventListener('page:load', initAuth);
